import { GET_MAP_POSITIONS, GET_MAP_POSITIONS_SUCCESS, GET_MAP_POSITIONS_ERROR } from "./actionTypes";

export const getMapPositions = (user, history) => {
  return {
    type: GET_MAP_POSITIONS,
    payload: { user, history },
  };
};

export const getMapPositionsSuccess = (message, map_positions) => {
  return {
    type: GET_MAP_POSITIONS_SUCCESS,
    payload: { message, map_positions },
  };
};

export const getMapPositionsError = (message) => {
  return {
    type: GET_MAP_POSITIONS_ERROR,
    payload: message,
  };
};
